export enum GameUIState
{
    EXIT,
    CAMERA,
    CHAT,
    HEADLINE,
}
